import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LoggedInUserService } from '../../../../core/services/loggedInUser/logged-in-user.service';

@Injectable({
  providedIn: 'root',
})
export class LayoutGuard implements CanActivate {

  constructor(private loggerInUser: LoggedInUserService, private router: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.loggerInUser.getLoggedInUser() &&
      (this.loggerInUser.getLoggedInUser().role === 'admin'
        || this.loggerInUser.getLoggedInUser().role === 'supervisor')
    ) {
      return true;
    } else {
      localStorage.clear();
      this.router.navigate(['/auth/login']).then(() => false);
      return false;
    }
  }
}
